import {Brick, registerBrick} from 'olympe';

/**
 * This brick generate a random string of 10 characters
 */
export default class GenerateRandomString extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Array} inputs
     * @param {function()} forwardEvent
     * @param {function(string)} setRandomString
     */
    update($, inputs, [forwardEvent, setRandomString]) {
        setRandomString((Math.random() + 1).toString(36).substring(2));
        forwardEvent();
    }
}

registerBrick('0192e6b29097ee0ba1f1', GenerateRandomString);
